

























helpers = require('../../helpers.coffee')

view_model = {
  props:
    template:
      default: {}
}

exports.default = helpers.vue_include(view_model, helpers.form, helpers.filters)




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/templates/preview.vue